import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../routes';
import QssnLogo from './QssnLogo';

const mono: React.CSSProperties = { fontFamily: "'JetBrains Mono', monospace" };

const footerLink: React.CSSProperties = {
  color: 'var(--ink-2)',
  textDecoration: 'none',
  fontSize: '.9375rem',
  lineHeight: 1.4,
};

const navLinks = [
  { label: 'How it works', to: ROUTES.howItWorks },
  { label: 'Security', to: ROUTES.security },
  { label: 'Impact', to: ROUTES.caseStudies },
];

type Props = { cta?: boolean };

const Footer: React.FC<Props> = () => (
  <footer style={{ background: 'var(--bg-alt)', color: 'var(--ink)', borderTop: '1px solid var(--line)' }}>
    <div
      className="qssn-footer-main"
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '3rem 1.5rem 1.5rem',
        display: 'grid',
        gridTemplateColumns: 'minmax(0,1.4fr) minmax(10rem,.6fr) minmax(12rem,.7fr)',
        gap: '2.5rem 4rem',
      }}
    >
      <div>
        <Link to={ROUTES.home} aria-label="QSSN home" style={{ display: 'inline-flex', color: 'var(--ink)' }}>
          <QssnLogo height={24} />
        </Link>
        <p style={{ margin: '1rem 0 0', maxWidth: '28rem', fontSize: '1rem', lineHeight: 1.55, color: 'var(--ink-2)' }}>
          Quantum-safe control infrastructure for regulated digital assets.
        </p>
      </div>

      <nav aria-label="Footer navigation" style={{ display: 'grid', gap: '.65rem', alignContent: 'start' }}>
        <div style={{ ...mono, fontSize: '.625rem', letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: '.15rem' }}>
          Links
        </div>
        {navLinks.map((link) => (
          <Link key={link.label} to={link.to} style={footerLink}>
            {link.label}
          </Link>
        ))}
      </nav>

      <div style={{ display: 'grid', gap: '.65rem', alignContent: 'start' }}>
        <div style={{ ...mono, fontSize: '.625rem', letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: '.15rem' }}>
          Contact
        </div>
        <a href="mailto:desk@btq.com" style={footerLink}>desk@btq.com</a>
        <Link to={ROUTES.contact} style={{ ...footerLink, color: 'var(--accent)', fontWeight: 500 }}>
          Talk to us
        </Link>
      </div>
    </div>

    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '1.25rem 1.5rem 2rem' }}>
      <div
        style={{
          borderTop: '1px solid var(--line)',
          paddingTop: '1.25rem',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '.75rem 2rem',
          color: 'var(--ink-3)',
        }}
      >
        <span style={{ fontSize: '.8125rem', lineHeight: 1.5 }}>QSSN is powered by BTQ Technologies.</span>
        <span style={{ ...mono, fontSize: '.6875rem', letterSpacing: '.12em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
          © 2026 BTQ Technologies
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
